import { createTheme, responsiveFontSizes } from "@mui/material";
import palette from "./palette";
import typography from "./typography";

const theme = responsiveFontSizes(
  createTheme({
    palette,
    typography,
    layout: {
      contentWidth: 1140,
    },
    zIndex: {
      appBar: 1200,
      drawer: 1100,
    },
    overrides: {
      MuiButton: {
        containedSecondary: {
          color: "white",
        },
      },
    },
  })
);

export default theme;
